// automatically generated by the FlatBuffers compiler, do not modify

export enum EscalatorService {
  Auto = 0,
  MOS = 1,
  Inspection = 2,
  Construction = 3,
  Run = 4
}
